var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 100,
    viewBox: "0 0 107 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 106,
    height: 100,
    rx: 50,
    fill: "#F7F8FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_2504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9257 54.0859C34.3351 55.1274 34.0639 56.3196 34.1458 57.5141C34.1765 57.9523 34.3438 60.186 36.2499 61.6044C37.1928 62.2897 38.3336 62.6488 39.499 62.6269C40.5714 65.0293 41.7968 67.3604 43.1676 69.6059C44.8899 72.4333 45.7852 73.847 47.3804 75.025C49.2531 76.3536 51.4634 77.1255 53.7561 77.2516C56.1775 77.4125 58.5954 76.8908 60.7351 75.746C63.1996 74.4101 64.4578 72.643 66.1542 70.2727C67.8622 67.8704 69.2196 65.2373 70.1856 62.4526C71.176 62.3699 72.119 61.9924 72.8928 61.3688C74.3419 60.1483 74.5893 58.2798 74.8178 56.5575C75.0463 54.8351 74.7683 54.6231 74.8791 52.5874C75.0016 50.2878 75.421 49.3971 75.8404 47.1117C76.247 44.9505 76.4286 42.7531 76.3823 40.5545C76.1231 34.7984 71.8561 30.5008 70.8477 29.4806C65.6665 24.2711 59.246 23.6891 56.1029 23.4135C53.094 23.1331 47.1047 22.5912 43.1676 26.3539C42.7255 26.7772 42.3233 27.2402 41.9659 27.737C40.3727 27.9887 38.8533 28.5836 37.5128 29.4806C34.0068 31.8626 33.0149 35.6655 32.4612 37.786C30.5079 45.2597 33.7547 51.9229 34.9257 54.0859Z",
    fill: "white",
    stroke: "#4540DB",
    strokeWidth: 1.64931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8675 54.3261C75.056 54.3261 75.1243 51.9841 75.5743 48.3768C75.9395 45.4693 76.161 44.8638 76.2812 43.6645C76.783 38.8556 74.6931 34.6922 74.097 33.5849C70.9775 27.8146 65.4099 25.647 62.8582 24.6527C60.396 23.6843 55.719 21.9384 50.0171 23.3615C47.0984 24.1055 44.3964 25.5279 42.1311 27.513C40.5758 27.8099 39.097 28.419 37.7839 29.3037C34.4241 31.5892 33.3096 35.0174 32.697 36.9023C31.3069 41.1787 31.9148 44.8214 32.254 46.7157C32.6944 49.1669 33.53 51.5302 34.728 53.7135C34.4352 50.5042 34.8238 47.2692 35.8684 44.2205C36.5752 42.173 37.3268 40.1303 39.3579 38.8862C40.7715 38.0168 42.1852 37.9437 43.1678 37.8825C46.8834 37.7034 49.765 39.5318 51.0279 40.4507L47.701 34.7229C51.8068 34.555 55.8866 35.4484 59.5466 37.3168C63.2065 39.1851 66.3231 41.9654 68.5954 45.3892C69.181 45.0698 69.696 44.6352 70.1094 44.1117C70.5228 43.5882 70.8261 42.9864 71.001 42.3427C71.6042 39.9583 70.0586 38.1322 69.9172 37.9697C71.1299 39.5274 72.1284 41.2407 72.8859 43.0637C75.2798 48.841 74.5894 54.3261 74.8675 54.3261Z",
    fill: "#BEBCFA",
    stroke: "#4540DB",
    strokeWidth: 1.64931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7259 51.0769C42.5316 50.3508 43.4908 49.8159 44.5321 49.5125C47.1687 48.7585 49.3999 49.814 49.9866 50.1156",
    stroke: "#4540DB",
    strokeWidth: 1.64931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2072 50.1158C59.6229 49.2495 61.3032 48.9216 62.9407 49.1922C64.3266 49.4424 65.6013 50.1147 66.5904 51.1172",
    stroke: "#4540DB",
    strokeWidth: 1.64931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4759 51.3574L52.5923 59.0998L57.3659 58.8641",
    stroke: "#4540DB",
    strokeWidth: 1.64931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6675 63.3502L58.9306 71.2904",
    stroke: "#4540DB",
    strokeWidth: 1.64931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0907 62.9495C56.0717 65.7424 53.0503 68.536 50.0266 71.3304",
    stroke: "#4540DB",
    strokeWidth: 1.64931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4567 53.5934C47.4197 53.5934 48.2003 52.8128 48.2003 51.8498C48.2003 50.8869 47.4197 50.1063 46.4567 50.1063C45.4938 50.1063 44.7132 50.8869 44.7132 51.8498C44.7132 52.8128 45.4938 53.5934 46.4567 53.5934Z",
    fill: "#4540DB",
    stroke: "#4540DB",
    strokeWidth: 1.64931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6163 53.3531C62.5792 53.3531 63.3598 52.5725 63.3598 51.6095C63.3598 50.6466 62.5792 49.866 61.6163 49.866C60.6533 49.866 59.8727 50.6466 59.8727 51.6095C59.8727 52.5725 60.6533 53.3531 61.6163 53.3531Z",
    fill: "#4540DB",
    stroke: "#4540DB",
    strokeWidth: 1.64931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_2504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.2136,
    height: 56.1001,
    fill: "white",
    transform: "translate(31 22)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeaf);
export default __webpack_public_path__ + "static/media/Deaf.59c6d5ed4793cc31a1c3b2aba0b13c0d.svg";
export { ForwardRef as ReactComponent };